import gql from 'graphql-tag'

export const resolveUnresolveCommentMutation = gql`
  mutation ResolveUnresolveComment($comment_id: Float!, $workspace_id: Float!) {
    resolveUnresolveComment(comment_id: $comment_id, workspace_id: $workspace_id) {
      status
      msg
      data
    }
  }
`
